import React, { useState, useEffect } from "react";

import Button from "react-bootstrap/Button";

const Viewer = (props) => {

    const [loading, setLoading] = useState(true);
    const [html, setHtml] = useState(props.html);
    const [view, setView] = useState(0)

    useEffect(() => {
        if(props.html){
            setHtml(props.html)
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        if(props.html){
            setLoading(true)
            setHtml(props.html)
            console.log("h3llo")
            setLoading(false)
        }
    }, [props.html])

    function copyClipboard(){
        navigator.clipboard.writeText(html);
    }

	function handleDownload() {
		const blob = new Blob([html], { type: 'text/html' });
    	const url = URL.createObjectURL(blob);

		// Create a temporary download link
		const link = document.createElement('a');
		link.href = url;
		link.download = 'emailcreator.html'; // Set the filename
		document.body.appendChild(link);
		link.click();

		// Clean up
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	}

    return (
    <>  
        <Button onClick={() => setView(0)}>Desktop</Button>
        <Button onClick={() => setView(1)}>Mobile</Button>
        <Button onClick={() => setView(2)}>View Code</Button>
        <Button onClick={() => copyClipboard()}>Copy Code to Clipboard</Button>
        <Button onClick={() => handleDownload()}>Download File</Button>
        {!loading && view === 0 && <iframe style={{width:"700px", height: "2000px"}} srcDoc={html}></iframe>}
        {!loading && view === 1 && <iframe style={{width:"600px", height: "2000px"}} srcDoc={html}></iframe>}
        {!loading && view === 2 && <div style={{backgroundColor: "#fff", width:"700px"}}>{html}</div>}
    </>)
  
};

export default Viewer;